module.exports = __webpack_public_path__ + "static/media/avatar.0b02d191.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/App/avatar.jpeg
// module id = 37
// module chunks = 0